import { Button } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type Props = {
  open: boolean
  onClose: () => void
}

export const NftIssuingModal: Organism<Props> = ({ open, onClose }) => {
  const { t } = useTranslation('ownedItemDetail')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('nftIssuingTitle')}
      content={t('nftIssuingContent')}
      buttons={
        <Button sx={{ width: 244 }} onClick={onClose}>
          OK
        </Button>
      }
    />
  )
}
